export const linkToQuiz = '/quiz'
